import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAds, LazySvgoBagTick, LazySvgoBullet, LazySvgoCalendar, LazySvgoCheckmark, LazySvgoCuteProfile, LazySvgoDanger, LazySvgoDiscovery, LazySvgoEr, LazySvgoGlob, LazySvgoGoftino, LazySvgoGreenOak, LazySvgoHome, LazySvgoInfoCircle, LazySvgoInstagram, LazySvgoMobile, LazySvgoNotification, LazySvgoOak, LazySvgoProfileCircle, LazySvgoProfile, LazySvgoRankBadge01, LazySvgoRankBadge02, LazySvgoRankBadge03, LazySvgoRankBadge04, LazySvgoRankBadge05, LazySvgoRankBadge06, LazySvgoSanjabLogo, LazySvgoSanjabTypography, LazySvgoSearchAdv, LazySvgoSignLogo, LazySvgoSimpleSearchEmptyState, LazySvgoSnOkStatusModalLeft, LazySvgoSnOkStatusModalRight, LazySvgoSn, LazySvgoTelegram, LazySvgoTrends, LazySvgoUserBehindUser, LazySvgoWarning } from '#components'
const lazyGlobalComponents = [
  ["SvgoAds", LazySvgoAds],
["SvgoBagTick", LazySvgoBagTick],
["SvgoBullet", LazySvgoBullet],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCheckmark", LazySvgoCheckmark],
["SvgoCuteProfile", LazySvgoCuteProfile],
["SvgoDanger", LazySvgoDanger],
["SvgoDiscovery", LazySvgoDiscovery],
["SvgoEr", LazySvgoEr],
["SvgoGlob", LazySvgoGlob],
["SvgoGoftino", LazySvgoGoftino],
["SvgoGreenOak", LazySvgoGreenOak],
["SvgoHome", LazySvgoHome],
["SvgoInfoCircle", LazySvgoInfoCircle],
["SvgoInstagram", LazySvgoInstagram],
["SvgoMobile", LazySvgoMobile],
["SvgoNotification", LazySvgoNotification],
["SvgoOak", LazySvgoOak],
["SvgoProfileCircle", LazySvgoProfileCircle],
["SvgoProfile", LazySvgoProfile],
["SvgoRankBadge01", LazySvgoRankBadge01],
["SvgoRankBadge02", LazySvgoRankBadge02],
["SvgoRankBadge03", LazySvgoRankBadge03],
["SvgoRankBadge04", LazySvgoRankBadge04],
["SvgoRankBadge05", LazySvgoRankBadge05],
["SvgoRankBadge06", LazySvgoRankBadge06],
["SvgoSanjabLogo", LazySvgoSanjabLogo],
["SvgoSanjabTypography", LazySvgoSanjabTypography],
["SvgoSearchAdv", LazySvgoSearchAdv],
["SvgoSignLogo", LazySvgoSignLogo],
["SvgoSimpleSearchEmptyState", LazySvgoSimpleSearchEmptyState],
["SvgoSnOkStatusModalLeft", LazySvgoSnOkStatusModalLeft],
["SvgoSnOkStatusModalRight", LazySvgoSnOkStatusModalRight],
["SvgoSn", LazySvgoSn],
["SvgoTelegram", LazySvgoTelegram],
["SvgoTrends", LazySvgoTrends],
["SvgoUserBehindUser", LazySvgoUserBehindUser],
["SvgoWarning", LazySvgoWarning],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
